import { render } from "./SocialMediaAuth.vue?vue&type=template&id=db633ee6&scoped=true"
import script from "./SocialMediaAuth.vue?vue&type=script&lang=js"
export * from "./SocialMediaAuth.vue?vue&type=script&lang=js"

import "./SocialMediaAuth.vue?vue&type=style&index=0&id=db633ee6&lang=scss&scoped=true"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db633ee6"]])

export default __exports__